const DefaultElement = props => <p {...props.attributes}>{props.children}</p>

export default DefaultElement
